import { Box } from '@moonpig/launchpad-components'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'

export const StyledProductsMessage = styled(Box)`
  ${s({
    mb: 8,
  })}

  display: block;
  width: 100%;
`

export const StyledProductsTitle = styled.h3`
  ${s({
    color: 'colorTextHeadline',
    mb: 3,
    typography: 'typeBodyLabel',
  })}
`

export const StyledProductsCarouselOverflow = styled.div`
  width: 100%;
  overflow-x: clip;
`
